  import { Injectable } from '@angular/core';
import { Headers } from '@angular/http';
import * as CryptoJS from 'crypto-js';

@Injectable()

export class KeyService{

    Headers = new Headers({
        'Cache-Control' : 'no-cache',
        'Pragma' : 'no-cache',
        'Expires' : 'Sat, 01 Jan 2000 00:00:00 GMT',
        'Access-Control-Allow-Origin':'*',
        'Access-Control-Allow-Methods':'OPTIONS,POST,GET'
      });

    headers = new Headers();

    constructor() {
        // this.headers.append("Access-Control-Allow-Credentials",'true');
        // this.headers.append("Access-Control-Max-Age",'1800');
        this.headers.append("Access-Control-Allow-Origin",'*');
        //this.headers.append("Access-Control-Allow-Headers",'*');
        this.headers.append("Access-Control-Allow-Methods","GET,POST,DELETE,PUT,HEAD,OPTIONS");

        this.headers.append("Content-Type","application/json");
        this.headers.append("usuarioid",localStorage.getItem('usuarioid'));
        this.headers.append("idusuario",localStorage.getItem('idusuario'));
        this.headers.append("nombreUsuario",localStorage.getItem('nombreUsuario'));
        this.headers.append("clave",localStorage.getItem('clave'));
        this.headers.append("sucursalid",localStorage.getItem('sucursalcliente'));
        this.headers.append("cedula",localStorage.getItem('cedulaUsuario'));
        this.headers.append("idperfil",localStorage.getItem('idperfil'));

        this.headers.append("prosof",localStorage.getItem('prosof'));
    }

    head() {
        return this.headers;
    }

    head2(){
      let headers = {
        "Access-Control-Allow-Origin":'*',
        "Access-Control-Allow-Methods":"OPTIONS,POST,GET",
        // "Access-Control-Allow-Headers":'*',
        "clave":localStorage.getItem('clave'),
        "cedula":localStorage.getItem('cedulaUsuario'),
        "nombreUsuario":localStorage.getItem('nombreUsuario'),
        "prosof":localStorage.getItem('prosof'),
        "sucursalid":localStorage.getItem('sucursalcliente'),
        "usuarioid":localStorage.getItem('usuarioid'),
        "idusuario":localStorage.getItem('idusuario'),
        "idperfil":localStorage.getItem('idperfil'),
       };
       return headers;
    }

    decryptData(data,key) {
      try {
        const bytes = CryptoJS.AES.decrypt(data, key);
        if (bytes.toString()) {
          return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        }
        return data;
      } catch (e) {
        console.log(e);
      }
    }
}



// WEBPACK FOOTER //
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/servicios/key.service.ts